import { Doctor } from "./doctor";
import { UserAccount } from "./user-account";

export class DoctorDetails {
  userAccount: UserAccount;
  doctor: Doctor;
  registrationFiles: any;
  constructor() {
    this.userAccount = new UserAccount();
    this.doctor = new Doctor();
  }
}
